import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Divider,
  Box,
  MenuItem,
} from "@mui/material";
import Input from "../../../../components/Input";
import { Close as CloseIcon } from "../../../../components/icons";
import ButtonComp from "../../../../components/Button";
import { useDrivers } from "../../../../hooks/useDrivers";
import { useEffect, useState } from "react";
import { canDriverUseVehicle } from "../../../../utils/fleetCompatibility";

type AssignVehiclePayload = {
  driverID: string;
  caseReference: string;
};

const initialFormData: AssignVehiclePayload = {
  driverID: "",
  caseReference: "",
};

const AssignVehiclePopup = ({ open, onClose, handleAssign, selectedVehicle }: any) => {
  const { drivers } = useDrivers({ availableOnly: true });
  const [formData, setFormData] = useState(initialFormData);
  const compatibleDrivers = drivers.filter((driver: any) =>
    selectedVehicle && canDriverUseVehicle(driver, selectedVehicle));

  useEffect(() => {
    if (!open) {
      setFormData(initialFormData);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby=""
      aria-describedby=""
      slotProps={{
        paper: {
          sx: {
            overflow: "hidden",
            width: { xs: "95%", sm: 800 },
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "primary.main",
          fontWeight: 600,
          fontSize: "25px",
        }}
      >
        Assign Vehicle
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ bgcolor: "primary.main", mx: 3 }} />

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Input
              select
              name="driverId"
              label="Assign Driver"
              value={formData.driverID}
              onChange={(e: any) =>
                setFormData({ ...formData, driverID: e.target.value })
              }
            >
              {compatibleDrivers.map((driver: any) => (
                <MenuItem key={driver.driverID} value={driver.driverID}>
                  {driver.firstName} {driver.lastName} · {String(driver.licenseCode || "Licence unknown").replaceAll("_", " ")}
                </MenuItem>
              ))}
            </Input>
            <Box fontSize={12} color="text.secondary" mt={0.5}>
              {compatibleDrivers.length
                ? "Showing available drivers licensed for this vehicle and its PDP requirement."
                : "No compatible drivers are currently available."}
            </Box>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Input
              fullWidth
              label="Case Reference"
              variant="outlined"
              value={formData.caseReference}
              onChange={(e: any) =>
                setFormData({ ...formData, caseReference: e.target.value })
              }
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" gap={3} mt={2}>
          <ButtonComp
            variant="outlined"
            width={140}
            height={45}
            onClick={onClose}
          >
            Cancel
          </ButtonComp>

          <ButtonComp
            variant="contained"
            width={140}
            height={45}
            onClick={() => handleAssign(formData)}
          >
            Assign
          </ButtonComp>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AssignVehiclePopup;
